export default __webpack_public_path__ + "static/media/french.91bf6bac.png";